import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TempleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TempleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M19.4268 22H6.19238C5.91601 22 5.69238 21.7764 5.69238 21.5V19.335C5.69238 18.4448 6.4165 17.7207 7.30664 17.7207H18.3125C19.2026 17.7207 19.9268 18.4448 19.9268 19.335V21.5C19.9268 21.7764 19.7031 22 19.4268 22ZM6.69237 21H18.9268V19.335C18.9268 18.9961 18.6514 18.7207 18.3125 18.7207H7.30663C6.96776 18.7207 6.69237 18.9961 6.69237 19.335V21Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9668 18.7207H7.65185C7.37548 18.7207 7.15185 18.4971 7.15185 18.2207V14.081C7.15185 12.5005 8.43798 11.2143 10.0186 11.2143H15.6001C17.1807 11.2143 18.4668 12.5005 18.4668 14.081V18.2207C18.4668 18.4971 18.2432 18.7207 17.9668 18.7207ZM8.15185 17.7207H17.4668V14.081C17.4668 13.0518 16.6294 12.2143 15.6001 12.2143H10.0186C8.98925 12.2143 8.15185 13.0518 8.15185 14.081V17.7207Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.0337 12.1631H9.58495C9.30858 12.1631 9.08495 11.9395 9.08495 11.6631V9.71533C9.08495 8.88623 9.75975 8.21191 10.5889 8.21191H15.0303C15.8594 8.21191 16.5337 8.88623 16.5337 9.71533V11.6631C16.5337 11.9395 16.3101 12.1631 16.0337 12.1631ZM10.085 11.1631H15.5337V9.71533C15.5337 9.43799 15.3081 9.21191 15.0303 9.21191H10.5889C10.311 9.21191 10.0849 9.43798 10.0849 9.71533L10.085 11.1631Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.8247 9.21191H10.7944C10.5181 9.21191 10.2944 8.98828 10.2944 8.71191V6.10839C10.2944 5.21825 11.0186 4.49364 11.9087 4.49364H13.7105C14.6006 4.49364 15.3247 5.21825 15.3247 6.10839V8.71191C15.3247 8.98828 15.1011 9.21191 14.8247 9.21191ZM11.2944 8.21191H14.3247V6.10839C14.3247 5.76952 14.0493 5.49364 13.7104 5.49364H11.9087C11.5698 5.49364 11.2944 5.76952 11.2944 6.10839L11.2944 8.21191Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.8096 5.36279C12.5332 5.36279 12.3096 5.13916 12.3096 4.86279V2.5C12.3096 2.22363 12.5332 2 12.8096 2C13.0859 2 13.3096 2.22363 13.3096 2.5V4.86279C13.3096 5.13916 13.0859 5.36279 12.8096 5.36279Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default TempleIcon;
